import {Directive, Injectable} from '@angular/core';
import {AbstractControl, ValidationErrors} from "@angular/forms";

@Injectable({
    providedIn: 'root'
})
@Directive({
    selector: '[appConfirmPassword]'
})
export class ConfirmPasswordDirective {
    constructor() {
    }

    validate(control: AbstractControl): ValidationErrors | null {
        const password = control.get('password')?.value;
        const confirmPassword = control.get('confirmPassword')?.value

        if (confirmPassword == null || confirmPassword == "") {
            return null;
        }

        return password !== confirmPassword ? {notEqual: true} : null;
    }
}